import { useLocation } from "react-router-dom";

import { ClusterDetailPage } from "../ClusterDetail";
import { type TimeRange } from "../ClusterDetail/Components/TimeRangeSelector";
import { Fsk8sPage } from "../Fsk8sPage";

const KubernetesLens = () => {
  const location = useLocation();

  const params = new URLSearchParams(location.search);
  const clusterId = params.get("cluster");
  const timeRange = params.get("timeRange");

  if (clusterId) {
    return (
      <ClusterDetailPage clusterId={clusterId} initialTimeRange={timeRange ? (timeRange as TimeRange) : undefined} />
    );
  }

  return <Fsk8sPage />;
};

export default KubernetesLens;
